import React from 'react';
import PropTypes from 'prop-types';

/**
  * @group THD Home Components
  * Curation
  */

class Curation extends React.Component {
  static async getThdCuration() {
    const { default: curationWidget } = await import(/* webpackChunkName: "common" */ 'thd-curation');
    return curationWidget;
  }

  async componentDidMount() {
    const curationWidget = await Curation.getThdCuration();
    curationWidget.init();
  }

  render() {
    const { opts = {} } = this.props;
    const {
      id,
      name,
      curationId,
      numberProducts,
      showProductLabel,
      showReviews,
      showPrice,
      showTitle,
      gridSize,
      showAddToCart,
      showAddToList
    } = opts;
    return (
      <div
        className="EtchCurationModule js-curation-container js-grid-container"
        data-module-id={id}
        id={id}
        data-view-type="grid"
        data-name={name}
        data-curation-id={curationId}
        data-number-products={numberProducts}
        data-show-product-label={showProductLabel}
        data-show-reviews={showReviews}
        data-show-price={showPrice}
        data-show-title={showTitle}
        data-grid-size={gridSize}
        data-show-add-to-cart={showAddToCart}
        data-show-add-to-list={showAddToList}
      />
    );
  }
}

Curation.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    curationId: PropTypes.string,
    numberProducts: PropTypes.string,
    showProductLabel: PropTypes.bool,
    showReviews: PropTypes.bool,
    showPrice: PropTypes.bool,
    showTitle: PropTypes.bool,
    gridSize: PropTypes.string,
    showAddToCart: PropTypes.bool,
    showAddToList: PropTypes.bool
  }).isRequired,
};

export default Curation;
